import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "user-management"
    }}>{`User Management`}</h1>
    <h2 {...{
      "id": "super-admin-to-user-management"
    }}>{`Super Admin to User Management`}</h2>
    <p>{`Super admin is a role who has the authority to run a complete `}<inlineCode parentName="p">{`CRUD`}</inlineCode>{` ( Create, Read, Update, Delete ) operation on this feature,Like Super admin Can add or block Vendor,Staff & Customer. Also can change permissions to any user.`}</p>
    <p>{`Super admin also has access to know all the listed vendors, their staffs, all the Customers of his/her site.`}</p>
    <p><img alt="super-admin-user-list" src={require("../images/revamp/super-admin-user-list.png")} /></p>
    <h2 {...{
      "id": "vendor--staff"
    }}>{`Vendor & Staff`}</h2>
    <p>{`As a vendor, he/she can add, update or delete his/her staff of each shop. Vendor also can build his/her profile section. Staffs are the helping hand of a vendor's shop. But one shop's staff has no access to another shop of the same vendor.`}</p>
    <h2 {...{
      "id": "customer"
    }}>{`Customer`}</h2>
    <p>{`In `}<inlineCode parentName="p">{`Customer`}</inlineCode>{` menu you will get the Customer list and you can add, remove or modify Customer from there. Customer has the access only in shop end. Where he can build his profile if he wish. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      